import "core-js/modules/es.array.concat.js";
export var baseURL = window["_baseURLIt"];
export var handleAxiosError = function handleAxiosError(error) {
  var cause = "errorMessage: ".concat(error.message, " \n");
  //ErrorCode !== 200 with server response
  if (error.response) {
    console.error("".concat(cause, " errorCode: ").concat(error.response.status, " \n ").concat(error.request.responseText));
  }
  //ErrorCode !== 200 WITHOUT server response
  else if (error.request) {
    console.error("".concat(cause, " \n ").concat(error.request));
  }
  //Error in request setup
  else {
    console.error(cause);
  }
};